module.exports = __webpack_public_path__ + "img/house-img2.fb3ecf91.jpg";